import { useMemo } from 'react'

import { createRangeStep } from '~/utils/functions'

type Props = {
  min?: string | number
  max?: string | number
  intervals?: any[]
  options?: any[]
  isMinReverse?: boolean
}

const useRangeOptions = ({
  min,
  max,
  intervals,
  options: currentOptions
}: Props) => {
  const options = useMemo(() => {
    let newOptions

    if (intervals?.length) {
      const range = createRangeStep(+min, +max, intervals)

      newOptions = range.slice(1, -1)
    } else if (currentOptions?.length) {
      newOptions = currentOptions
    }

    return {
      min: newOptions,
      max: newOptions?.slice().reverse()
    }
  }, [min, max, currentOptions])

  return options
}

export default useRangeOptions
